import RequestService from './request';

class AuditLogActionsService {
    get(): Promise<string[]> {
        return RequestService.getCached('audit-log-actions', '/audit-log-actions').then((res) => res.data ?? []);
    }
}

export default new AuditLogActionsService();
